import { EventApi, MenuApi } from 'api'
import { TopLevelPage, ModelGrid } from 'ui'
import { withErrorBoundary, connected } from 'shared'
import PropTypes from 'prop-types'

const MenuItems = (props) => {

  let { menuId, id, subId } = props.match.params
  let menu = application.state.getModel(`menu:${menuId}`)
  let models = Number(menuId) > 0 || menuId == 'saved_amenities' ?
    MenuApi.kick('show', { id: menuId }, {actionId: `${menuId}`}) :
    EventApi.kick(menuId)
  let base = `menu/${menuId}`
  let modalBase = subId ? base + `/${id}` : base
  let modelId = subId || id

    return (
      <TopLevelPage className="CustomMenu" modelId={modelId} base={modalBase} pageTitle={menu?.name}>
        <ModelGrid models={models} base={base} pageTitle={menu?.name} />
      </TopLevelPage>
    )
}

MenuItems.propTypes = {
  match: PropTypes.object
}

export default withErrorBoundary(connected(MenuItems))
